<button class="scroll-top-btn" *ngIf="showScrollButton" (click)="scrollToTop()">
  <i class="fa-solid fa-angle-up fa-lg"></i>
</button>